import React from "react";
import Layout from "components/Layout";
import { Box, Text } from "@chakra-ui/react";
import Head from "next/head";

const ModernSlaveryAct: React.FC = () => {
  return (
    <Layout>
      <Head>
        <title>101Digital | Modern Slavery Act</title>
      </Head>
      <Text
        as="h1"
        textStyle="h1"
        textAlign={["center", null, null, null, null, "left"]}
        mb={["34px", null, null, null, null, "136px"]}
        mt={["45px", null, null, null, null, "132px"]}
      >
        <Text>Modern Slavery Act</Text>
      </Text>
      <Box
        maxW="1155px"
        w="100%"
        mb={["34px", null, null, null, null, "99px"]}
        px={["28px", null, null, null, null, "16px"]}
      >
        <Text
          textStyle="paragraph"
          color="primary"
          fontSize={["12px", null, null, null, null, "21px"]}
          fontWeight={300}
        >
          As a leading provider of Digital Platforms and solutions to Banks and
          Multi-Nationals, we understand that we need to lead by example in the
          way we do business. All of us at 101 Digital PTE LTD are bound by a
          common purpose and set of values which shapes the way we do business
          and act to ensure we are helping people to achieve their ambitions –
          in the right way. This also means we aim to act fairly, ethically and
          openly in everything we do.
          <br />
          <br />
          This statement sets out the steps that 101 Digital PTE LTD has taken
          in relation to our responsibilities under UK Modern Slavery Act 2015
          (the Modern Slavery Act) to mitigate the risk of slavery and human
          trafficking. We are committed to act with integrity in all our
          business activities and comply with the said Act.
          <br />
          <br />
          101 Digital PTE upholds human rights principles to ensure that slavery
          and human trafficking are not taking place within our directly
          employed workforce, contractors, sub-contractors, and any of our
          business partners. We promote best practice in our supply chain and
          require that all our current and prospective third-party service
          providers and vendors, working with and on behalf of 101 Digital, to
          be conscious of our principles and act in accordance with them.
        </Text>
      </Box>
    </Layout>
  );
};

export default ModernSlaveryAct;
